/**
 * selectionStore — 全局选中态 Store（Zustand）
 *
 * 管理跨页面共享的选中状态：节点、公司、链路。
 * 这是图谱↔排名↔象限联动的地基。
 */
import { create } from 'zustand';

export type ChainKey = 'all' | 'nvidia' | 'google' | 'huawei';

interface SelectionState {
  // 当前选中的节点 ID（图谱点击）
  selectedNodeId: string | null;
  // 当前选中的公司 ID（排名表/象限点击）
  selectedCompanyId: string | null;
  // 当前链路
  focusedChain: ChainKey;

  // 动作
  selectNode: (id: string | null) => void;
  selectCompany: (id: string | null) => void;
  setChain: (chain: ChainKey) => void;
  // 清空所有选中（点击空白）
  clearSelection: () => void;
}

export const useSelectionStore = create<SelectionState>((set) => ({
  selectedNodeId: null,
  selectedCompanyId: null,
  focusedChain: 'all',

  selectNode: (id) => set({ selectedNodeId: id }),
  selectCompany: (id) => set({ selectedCompanyId: id }),
  setChain: (chain) => set({ focusedChain: chain }),
  clearSelection: () => set({ selectedNodeId: null, selectedCompanyId: null }),
}));
